
/* injects from baggage-loader */

'use strict';

export default class AccountChangePasswordController {

	constructor($log, $state, User, Parse, Alerts) {
		'ngInject';

		this.heading = 'Change Password';

		this.$log = $log;
		this.$state = $state;
		this.User =  User;
		this.Parse = Parse;
		this.Alerts = Alerts;

		// Title displayed on the simple form template
		this.formTitle = 'Change password';

		this.password = {};
		this.enableSaveButton = false;

		// Password Form
		this.formTemplate = {

			model: this.password,

			// Classes
			class: ['row'],

			// Form input groups
			// Currently only simple fields are supported
			// ex. text, email, number
			fields: [
				{
					type: 'password',
					label: 'Current password',
					model: 'current',
					autocomplete: 'password',
					describedby: 'currentPassword',
					class: ['col-lg-6', 'col-12'],
					onChange: () => {
						this.checkPasswordFields();
					}
				},
				{
					type: 'password',
					label: 'New password',
					model: 'new',
					autocomplete: 'new-password',
					describedby: 'newPassword',
					class: ['col-lg-6', 'col-12'],
					onChange: () => {
						this.checkPasswordFields();
					}
				},
				{
					type: 'password',
					label: 'Confirm password',
					model: 'confirm',
					autocomplete: 'new-password',
					describedby: 'confirmPassword',
					class: ['col-lg-6', 'col-12'],
					onChange: () => {
						this.checkPasswordFields();
					}
				}
			],

			// Action button at the end of the form
			submit: {
				text: 'Update password',
				action: () => {
					this.updatePassword();
				},
				disabled: () => !this.enableSaveButton
			}

		};

	}

	$onInit() {

		// Clear local alerts
		this.Alerts.clearLocal();

	}

	$onDestroy() {

		// Clear local alerts
		this.Alerts.clearLocal();

	}


	/**
	 * Function called each time the password inputs are modified.
	 * Checks for the following cases to evaluate as true
	 *  - All fields are filled out
	 */
	checkPasswordFields() {
		if (this.password.current && this.password.new && this.password.confirm) {
			this.enableSaveButton = true;
		} else {
			this.enableSaveButton = false;
		}
	}


	/**
	 * Calls the cloudcode function to save the users new password
	 */
	updatePassword() {

		// Clear error message
		this.Alerts.clearLocal();

		// Check that new passwords are matching
		if (this.password.new !== this.password.confirm) {
			this.Alerts.setLocal({
				type: 'danger',
				msg: 'New passwords do not match.'
			});
			this.$log.log('no match')
			this.enableSaveButton = false;
			return false;
		}

		// Run cloud code function to save new password
		this.Parse.Cloud.run('changePassword', {
			p: this.password.current,
			np: this.password.new
		}).then(() => {

			// Password updated successfully
			this.Alerts.setLocal({
				type: 'success',
				msg: 'Password updated successfully'
			});

			// Reauthenticate the user with new password
			this.User.authenticate({
				email: this.user.getUsername(),
				password: this.password.new
			})
				.then(() => {
					/* empty */
				})
				.catch(err => {
					this.$log.error(err);
					// Something went wrong, logout user to manaully reauthenticate
					this.$state.go('logout');
				})

			// Clear fields
			this.password = {};

		})
			.catch(err => {

				// Something went wrong
				this.$log.error(err);

				if (err.code === 101) {
					this.Alerts.setLocal({
						type: 'danger',
						msg: 'Failed to update password, the current password was entered incorrectly.'
					});
				} else {
					this.Alerts.setLocal({
						type: 'danger',
						msg: 'Failed to update password! Please contact support if the problem persists.'
					});
				}

			});

	}




}



// WEBPACK FOOTER //
// ./src/app/pages/account/change-password/account.change-password.controller.js